<template>
  <div class="email-wishlist-modal">
    <CustomModal :show="show"
                 @close="onClose">
      <template #header>
        <h1 class="custom-modal__heading">
          Email wish list
        </h1>
      </template>
      <div class="email-wishlist__body">
        <form @submit.prevent="onSubmit">
          <p v-if="warningMessage"
             class="warning-message">
            <b>
              {{ warningMessage }}
            </b>
          </p>
          <p>
            Who would you like to send <b>{{ wishlist.title }}</b> to?
          </p>
          <div class="form-group">
            <input
              v-model="email"
              class="form-control"
              type="email"
              name="email"
              placeholder="Email address"
              aria-label="Email address">

            <span v-if="showValidation && !email"
                  class="validation-error">
              Please enter a valid email address.
            </span>
          </div>
          <button class="btn btn-accent-1"
                  :disabled="submitting || submitted">
            <template v-if="submitting">
              <span class="visually-hidden">
                Sending...
              </span>
              <font-awesome-icon icon="spinner"
                                 spin></font-awesome-icon>
            </template>
            <template v-else-if="submitted">
              <span class="visually-hidden">
                Wishlsit sent
              </span>
              <font-awesome-icon icon="check"></font-awesome-icon>
            </template>
            <template v-else>
              Send
              <font-awesome-icon :icon="['far', 'paper-plane']">
              </font-awesome-icon>
            </template>
          </button>
        </form>
      </div>
    </CustomModal>
  </div>
</template>

<script>
import CustomModal from "~/Components/CustomModal.vue";
import { emailWishlist } from "~/Scripts/resources/wishlistResource";

export default {
  name: "EmailWishlistModal",
  components: {
    CustomModal
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    wishlist: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      email: null,
      showValidation: false,
      submitting: false,
      submitted: false
    };
  },
  computed: {
    isValid () {
      let result = false;

      if ( this.email ) {
        result = true;
      }

      return result;
    },
    warningMessage () {
      let result = null;

      if ( this.wishlist && this.wishlist.sopLines && this.wishlist.sopLines.length === 0 ) {
        result = "The wish list you're about to send is empty!";
      }

      return result;
    }
  },
  watch: {
    show ( val ) {
      if ( val ) {
        this.email = null;
        this.submitting = false;
        this.submitted = false;
        this.showValidation = false;
      }
    }
  },
  methods: {
    onSubmit () {
      this.showValidation = true;

      if ( this.isValid ) {
        this.submitting = true;

        emailWishlist( this.wishlist.id, this.email )
          .then( result => {
            if ( result && result.data ) {
              this.submitted = true;

              // Close the modal 2 seconds after submitting
              window.setTimeout( () => {
                this.onClose();
              }, 2000 );
            }
          } )
          .catch( error => {
            console.log( "error emailing wishlist", error );
            throw error;
          } )
          .finally( () => {
            this.submitting = false;
          } );
      }
    },
    onClose () {
      this.$emit( "onClose" );
    }
  }
};
</script>

<style lang="less" scoped>
.warning-message {
  color: #ed650b;
}
</style>
